// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_UzMV1 clearfix","box_r":"index_box_r_D0gOs","d_box":"index_d_box_ePDQ5"};